import styled from 'styled-components'
import { useHttpLocations } from '@pancakeswap/hooks'
import Logo from './Logo'

const StyledListLogo = styled(Logo)<{ children?: import('react').ReactNode; size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
`

export default function ListLogo({
  logoURI,
  style,
  size = '24px',
  alt,
}: {
  logoURI: string
  size?: string
  style?: React.CSSProperties
  alt?: string
}) {
  const srcs: string[] = useHttpLocations(logoURI)

  return <StyledListLogo alt={alt} size={size} srcs={srcs} style={style} />
}
